import { useCallback, useEffect, useState } from "react";

import Combobox from "../../../shared/ui/Field/Combobox";
import Field from "../../../shared/ui/Field/Field";
import { MIN_ADDRESS_OBJECT_QUERY_LENGTH } from "../api/geo";
import { useGeoAddressObjectSearch } from "../hooks/useGeoAddressObjectSearch";

function GeoAddressObjectAutocomplete({
  id,
  settlementCode,
  enabled,
  selectedAddressObject,
  onSelect,
  error,
  disabled = false,
}) {
  const [query, setQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const { options, loading, error: searchError } = useGeoAddressObjectSearch({
    settlementCode,
    query,
    enabled: enabled && !disabled,
  });

  useEffect(() => {
    if (!selectedAddressObject) {
      setQuery("");
      setIsSearching(false);
    }
  }, [selectedAddressObject]);

  useEffect(() => {
    setQuery("");
    setIsSearching(false);
  }, [settlementCode]);

  const displayValue =
    selectedAddressObject && !isSearching ? selectedAddressObject.name : query;

  const handleChange = useCallback((event) => {
    setIsSearching(true);
    setQuery(event.target.value);
  }, []);

  const handleSelect = useCallback(
    (option) => {
      if (!option?.raw) return;
      setQuery("");
      setIsSearching(false);
      onSelect(option.raw);
    },
    [onSelect],
  );

  const handleOpen = useCallback(() => {
    if (selectedAddressObject && !isSearching) {
      setIsSearching(true);
      setQuery("");
    }
  }, [isSearching, selectedAddressObject]);

  const trimmedQuery = query.trim();
  const showNoResults =
    trimmedQuery.length >= MIN_ADDRESS_OBJECT_QUERY_LENGTH;

  return (
    <div className="geo-address-object-autocomplete geo-canonical-field">
      <Field
        id={id}
        label="Вулиця або адресний об’єкт (необов’язково)"
        help={
          disabled || !enabled
            ? "Спочатку оберіть населений пункт."
            : "Введіть щонайменше 2 символи для пошуку в довіднику."
        }
        error={error}
        className="geo-canonical-field__field"
      >
        <Combobox
          name={id}
          value={displayValue}
          onChange={handleChange}
          options={options}
          loading={loading}
          error={searchError}
          disabled={disabled || !enabled}
          emptyHint={
            enabled && !disabled
              ? "Введіть назву вулиці або адресного об’єкта (мінімум 2 символи)."
              : undefined
          }
          emptyResultsLabel={
            showNoResults
              ? `За запитом «${trimmedQuery}» нічого не знайдено.`
              : undefined
          }
          onSelect={handleSelect}
          onOpen={handleOpen}
          placeholder={
            disabled || !enabled
              ? "Спочатку оберіть населений пункт"
              : "Напр.: Незалежності"
          }
          autoComplete="off"
        />
      </Field>
    </div>
  );
}

export default GeoAddressObjectAutocomplete;
